import { useQuery } from '@tanstack/react-query'
import { Space, Switch } from 'antd'
import customerApi from 'api/customerApi'
import { thunkGetCustomerList } from 'features/Category/categorySlice'
import ModalEditCustomer from 'features/Category/components/ModalEditCustomer'
import ViewImportFile from 'features/Category/components/ViewImportFile'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import KTFormSelect from 'general/components/Forms/KTFormSelect'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import VIModal from 'general/components/eInvoiceComponents/VIModal'
import AppData from 'general/constants/AppData'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import ToastHelper from 'general/helpers/ToastHelper'
import Global from 'general/utils/Global'
import Utils, { getParam } from 'general/utils/Utils'
import useAppDnD from 'hooks/useAppDnD'
import useFilter from 'hooks/useFilter'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useMemo, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import fileSample from '../../components/ViewImportFile/Mau_danh_muc_khach_hang.xls'
import { useSelector } from 'react-redux'
import axiosClient from 'api/axiosClient'
import businessBranchApi from 'api/businessBranchApi'
import ModalEditBusnessBranch from 'features/Category/components/ModalEditBusnessBranch'

function BusinessBranchScreen() {
  // MARK --- Parmas: ---
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const { taxCode } = useSelector((state) => state.auth?.currentCompany)

  const systemInvoiceType = useAppSelector((s) => s.auth?.activeInvoice)
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const [filters, setFilters] = useFilter(
    'businessBranchList',
    'gFiltersBusinessBranchList',
  )
  const {
    isLoading: gettingListData,
    refetch: refreshData,
    data: businessBranchs,
  } = useQuery({
    queryKey: [
      'getListBusinessBranch-businessBranchScreen',
      filters,
      systemInvoiceType.ticket,
      systemInvoiceType.invoice,
      debouncedSearch,
    ],
    queryFn: () =>
      businessBranchApi.find({
        ...filters,
        q: debouncedSearch,
      }),

    select: (res) => {
      return {
        total: _.get(res, 'result.count', 0),
        rows: _.get(res, 'result.rows', []),
      }
    },
  })
  const [selectedBranchScreens, setSelectedBranchScreens] = useState([])
  const [toggleClearCustomers, setToggledClearCustomers] = useState(false)
  const [selectedBusinessBranchItem, setSelectedBusinessBranchItem] =
    useState(null)
  const [showingModalEditBusiness, setShowingModalEditBusiness] =
    useState(false)
  const [active, setActive] = useState('ADD')
  const [modalImportShowing, setModalImportShowing] = useState(false)

  const handleDeleteCustomer = useCallback(
    (item) => {
      Swal.fire({
        title: t('Xác nhận'),
        text: `Bạn có muốn xóa địa điểm kinh doanh ${item.businessBranchName}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: t('Đồng ý'),
        cancelButtonText: t('Hủy'),
        customClass: {
          confirmButton: 'btn btn-danger font-weight-bolder',
          cancelButton: 'btn btn-light font-weight-bolder',
        },
      }).then(async function (result) {
        if (result.value) {
          try {
            const res = await businessBranchApi.delete([
              item.businessBranchCode,
            ])
            if (res.result === 'success') {
              Global.gNeedToRefreshCustomerList = true
              ToastHelper.showSuccess(t('Xóa địa điểm kinh doanh thành công'))
              refreshData()
              // dispatch(thunkGetCustomerList(Global.gFiltersCustomerList))
            }
          } catch (error) {
            console.log(`Delete customer error: ${error?.message}`)
          }
        }
      })
    },
    [refreshData, t],
  )
  const fullColumns = useMemo(
    () => [
      {
        name: 'Mã địa điểm kinh doanh',
        // sortable: false,
        width: '250px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal q-max-line-1 m-0 text-maxline-3 mr-4"
            >
              {row?.businessBranchCode}
            </p>
          )
        },
      },
      {
        name: 'Tên địa điểm kinh doanh',
        // sortable: false,
        minWidth: '150px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="q-max-line-3  font-weight-normal  m-0 text-maxline-3 mr-4"
            >
              {row?.businessBranchName}
            </p>
          )
        },
      },
      {
        name: 'Địa chỉ địa điểm kinh doanh',
        // sortable: false,
        width: '350px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal q-max-line-1 m-0 text-maxline-3 mr-4"
            >
              {row?.businessBranchAddress}
            </p>
          )
        },
      },
      {
        name: 'Mặc định sử dụng',
        width: '200px',
        center: true,
        style: {
          borderRight: 'none',
        },
        cell: (row) => {
          return (
            <div data-tag="allowRowEvents">
              <Switch
                checked={row?.defaultUsed}
                onChange={(checked) => {
                  setDefultUsed({
                    businessBranchCode: row?.businessBranchCode,
                    defaultUsed: checked,
                  })
                }}
              />
            </div>
          )
        },
      },
      {
        name: 'Trang thái sử dụng',
        width: '200px',
        center: true,
        style: {
          borderRight: 'none',
        },
        cell: (row) => {
          return (
            <div
              data-tag="allowRowEvents"
              className={`badge badge-light-${
                row?.statusUsed == 1 ? 'success' : 'warning'
              }`}
            >
              {row?.statusUsed == 1 ? 'Đang sử dụng' : 'Chưa sử dụng'}
            </div>
          )
        },
      },
      {
        name: 'Hành động',
        center: true,
        width: '150px',
        grow: 0,
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-between">
            <TableAction
              titleActionText={t('Edit')}
              icon={<IconAction className="fa-light fa-edit" />}
              onClick={() => {
                handleEdit(row)
              }}
            />
            <TableAction
              titleActionText={t('Delete')}
              icon={<IconAction className="fa-light fa-trash" />}
              onClick={() => {
                handleDeleteCustomer(row)
              }}
            />
          </div>
        ),
      },
    ],
    [handleDeleteCustomer, t],
  )

  // MARK --- Function ---

  function handleDeleteMultiCustomer() {
    // const arrIdsToDelete = selectedBranchScreens.map((item) => item.customerId)
    // Swal.fire({
    //   title: t('Xác nhận'),
    //   text: `Bạn có muốn xóa ${arrIdsToDelete.length} khách hàng ?`,
    //   icon: 'question',
    //   showCancelButton: true,
    //   confirmButtonText: t('Đồng ý'),
    //   cancelButtonText: t('Hủy'),
    //   customClass: {
    //     confirmButton: 'btn btn-danger font-weight-bolder',
    //     cancelButton: 'btn btn-light font-weight-bolder',
    //   },
    // }).then(async function (result) {
    //   if (result.value) {
    //     const customerIds = arrIdsToDelete
    //     try {
    //       const res = await businessBranchApi.delete(customerIds)
    //       if (res.result === 'success') {
    //         clearselectedBranchScreens()
    //         Global.gNeedToRefreshCustomerList = true
    //         ToastHelper.showSuccess(t('Xóa địa điểm kinh doanh thành công'))
    //         refreshData()
    //       }
    //     } catch (error) {
    //       console.log(`Delete businessBranch error: ${error?.message}`)
    //     }
    //   }
    // })
  }

  async function setDefultUsed({ businessBranchCode, defaultUsed }) {
    try {
      const res = await businessBranchApi.setDefultUsed({
        businessBranchCode,
        defaultUsed,
      })
      if (res.result === 'success') {
        ToastHelper.showSuccess(
          t('Cập nhật mặc định sử dụng địa điểm kinh doanh thành công'),
        )
        refreshData()
      }
    } catch (error) {
      console.log(`clearselectedBranchScreens error: ${error?.message}`)
    }
  }

  function clearselectedBranchScreens() {
    setSelectedBranchScreens([])
    setToggledClearCustomers((prev) => !prev)
  }

  function handleEdit(item) {
    setActive('EDIT')
    setSelectedBusinessBranchItem(item)
    setShowingModalEditBusiness(true)
  }

  function handleReplicateCustomer(customer) {
    setActive('REPLICATE')
    setSelectedBusinessBranchItem(customer)
    setShowingModalEditBusiness(true)
  }

  const [isSyncData, setIsSyncData] = useState(true)
  const { company } = useSelector((state) => state?.system)

  const fetchStatus = useCallback(async () => {
    if (company.companyId) {
      const statusRes = await axiosClient.get(
        `/company/status-sync/${company.companyId}`,
      )
      setIsSyncData(statusRes.result.isSyncCustomer)
    }
  }, [company.companyId])

  async function syncData() {
    setIsLoading(true)
    try {
      const response = await axiosClient.get(
        `/customer/oldcustomerDB?partyTaxId=${taxCode}`,
      )
      if (response.result) {
        fetchStatus()
      }
      refreshData()
    } catch (error) {
      console.error('Error syncing data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  useEffect(() => {
    if (getParam('type') == 'add') {
      setActive('ADD')
      setShowingModalEditBusiness(true)
    }
  }, [])

  const dynamicColumns = useAppDnD(fullColumns)

  return (
    <ContentContainer wrapperClassName="list-replaced-invoice">
      <ContentContainer.Header
        titleContent={t('Địa điểm kinh doanh')}
        description={`${t('Tổng')}: ${businessBranchs?.total} ${_.capitalize(
          t('Địa điểm kinh doanh'),
        )}`}
        toolBar={
          <Space>
            <CustomAntButton
              text={t('Thêm địa điểm kinh doanh')}
              iconCn="fa-regular fa-plus"
              antProps={{
                type: 'primary',
                onClick: () => {
                  setActive('ADD')
                  setShowingModalEditBusiness(true)
                },
              }}
            />
            <AppDnD
              defaultColumns={fullColumns}
              localStorageName={PreferenceKeys.savedColumnsbusinessBranch}
            />
          </Space>
        }
      >
        <Space>
          {selectedBranchScreens.length > 0 ? (
            <CustomAntButton
              iconCn="fa-regular fa-trash"
              text={Utils.cn(
                t('Xóa'),
                selectedBranchScreens.length,
                'địa điểm kinh doanh',
              )}
              antProps={{
                type: 'primary',
                danger: true,
                onClick: () => {
                  handleDeleteMultiCustomer()
                },
              }}
            />
          ) : (
            <>
              <CustomAntInput
                type="search"
                borderRadius="sm"
                inputProps={{
                  value: search,
                  onChange: (e) => setSearch(e.target.value),
                }}
              />
              {/* <label className="mr-2 mb-0" htmlFor="state">
                {_.capitalize(t('Trạng thái'))}
              </label>
              <KTFormSelect
                name="statusUsed"
                isCustom
                options={[{ name: 'Tất cả', value: '' }, ...AppData.statusUsed]}
                value={filters.status}
                onChange={(newValue) => {
                  setFilters({
                    page: 0,
                    statusUsed: newValue,
                  })
                }}
              /> */}
            </>
          )}
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={businessBranchs?.rows}
          isLoading={gettingListData}
          isClickable
          // isSelectable
          handleDoubleClickRow={(row) => handleEdit(row)}
          pagination={{
            currentPage: filters?.page + 1,
            rowsPerPage: filters?.limit,
            total: businessBranchs?.total,
            onChangePage: (newPage) => {
              let iNewPage = parseInt(newPage)
              if (iNewPage > 0) {
                iNewPage = iNewPage - 1
              }
              setFilters({
                page: iNewPage,
              })
            },
            onChangeRowsPerPage: (newPerPage) => {
              const iNewPerPage = parseInt(newPerPage)
              setFilters({
                limit: iNewPerPage,
                page: 0,
              })
            },
          }}
          selectedRows={{
            clearSelectedRows: toggleClearCustomers,
            handleSelectedRows: ({ selectedRows }) =>
              setSelectedBranchScreens(selectedRows),
            selectableRowSelected: (row) => {
              const arrId = selectedBranchScreens.map((item) => item.customerId)
              return arrId.includes(row.customerId)
            },
          }}
        />
      </ContentContainer.Body>

      {/* Modal customer edit */}
      <ModalEditBusnessBranch
        show={showingModalEditBusiness}
        onClose={() => {
          setShowingModalEditBusiness(false)
          setSelectedBusinessBranchItem(null)
        }}
        onRefreshCustomerList={() => {
          refreshData()
        }}
        active={active}
        businessBranchItem={selectedBusinessBranchItem}
      />

      {/* modal import */}
      <VIModal
        titleModal={t('Upload')}
        modalSize="lg"
        show={modalImportShowing}
        contentModal={
          <ViewImportFile
            onPressCancel={() => {
              setModalImportShowing(false)
            }}
            onDownloadSampleFile={() => {
              const link = document.createElement('a')
              link.href = fileSample
              link.download = 'Mau_danh_muc_khach_hang.xls'
              link.click()
            }}
            onUpload={async (file) => {
              const res = await customerApi.upload(file)
              if (res.result === 'success') {
                ToastHelper.showSuccess(t('ImportCustomerListSuccess'))
                dispatch(thunkGetCustomerList())
                setModalImportShowing(false)
              }
            }}
          />
        }
        closeBtn
        handleSubmit={() => {}}
        onHide={() => {
          setModalImportShowing(false)
        }}
      />
    </ContentContainer>
  )
}

export default BusinessBranchScreen
